import BuildingBridgesStoryboard from './components/BuildingBridgesStoryboard'

function App() {
  return (
    <div className="App">
      <BuildingBridgesStoryboard />
    </div>
  )
}

export default App
